import { IconActivity, IconShoppingBag, IconUserPlus, IconUsers } from "@tabler/icons-react"
import { type ComponentType, type FC } from "react"

import { toNumberFormat } from "@forento/core/utilities/number"

import { getProductCount, type UserItem } from "./shared"

const dayInMilliseconds = 24 * 60 * 60 * 1000

const Stats: FC<{ users: UserItem[] }> = ({ users }) => {
	const since = Date.now() - 30 * dayInMilliseconds

	const customers = users.filter(user => user.membership !== null || getProductCount(user) > 0).length

	return (
		<div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
			<Stat icon={IconUsers} label="Total users" value={users.length} />
			<Stat
				icon={IconUserPlus}
				label="New in 30 days"
				value={users.filter(user => user.registerDate.getTime() >= since).length}
			/>
			<Stat
				icon={IconActivity}
				label="Active in 30 days"
				value={
					users.filter(user => user.lastActiveDate !== null && user.lastActiveDate.getTime() >= since).length
				}
			/>
			<Stat
				icon={IconShoppingBag}
				label="Customers"
				value={customers}
				detail={users.length > 0 ? `${Math.round((customers / users.length) * 100)}% of users` : undefined}
			/>
		</div>
	)
}

type StatProps = { icon: ComponentType<{ className?: string }>; label: string; value: number; detail?: string }
const Stat: FC<StatProps> = ({ icon: Icon, label, value, detail }) => (
	<div className="border-component-border flex flex-col gap-3 rounded-2xl border bg-white p-5">
		<div className="flex items-center gap-2 text-gray-500">
			<Icon className="size-4 shrink-0" aria-hidden="true" />
			<span className="text-sm font-medium">{label}</span>
		</div>
		<div className="flex flex-wrap items-baseline gap-x-2">
			<span className="text-2xl font-bold tabular-nums">{toNumberFormat(value)}</span>
			{detail !== undefined && <span className="text-xs text-gray-500">{detail}</span>}
		</div>
	</div>
)

export default Stats
